import Base from './Base';

class Location extends Base {
  constructor() {
    super();

    this.id = 1;
    this.name = 'location';
    this.searchQuery = 'location';
    this.title = 'Location';
    this.isLocation = true;
  }

  getDefaultData() {
    return {
      stepId: this.id,
      id: '',
      name: '',
      formattedAddress: '',
      isHidden: false,
    };
  }

  getData({ location }) {
    return location;
  }

  getRequestParams({ location }) {
    return { locationId: location.id };
  }

  getStepDataFromAppointment({ location }, appointment) {
    return {
      ...location,
      id: appointment.locationId,
      name: appointment.locationName,
      formattedAddress: appointment.locationAddress,
      lat: appointment.locationLat,
      lng: appointment.locationLng,
    };
  }

  prepareResultData({ location }) {
    return {
      locationId: location.id,
      locationName: location.name, // TODO: remove this line
      locationAddress: location.formattedAddress, // TODO: remove this line
    };
  }

  excludeStepDataFromParams(params) {
    const { locationId, ...restParams } = params;
    return restParams;
  }

  fetchRecords(params, props) {
    return props.loadLocationsForBooking(params);
  }

  updateDataByRecords({ location }, records) {
    const firstLocation = records[0];
    return {
      location: {
        ...location,
        id: firstLocation.id,
        name: firstLocation.name,
      },
    };
  }
}

export default Location;
